var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoW(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;fill:#47B649;stroke:#000000;stroke-miterlimit:10;}\n\t.st2{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M494.1,250c0,134.8-109.3,244-244.1,244S2.6,384.7,6,250C9.4,115.2,118.2,5.9,250,5.9 C384.8,6,494.1,115.2,494.1,250z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000118395163527483954110000003992568716903723658_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      display: "inline",
      overflow: "visible",
      enableBackground: "new"
    },
    width: 1527,
    height: 1527,
    xlinkHref: "682CC89C.jpeg",
    transform: "matrix(0.332 0 0 0.332 0 0)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000145042436112501654970000011078332185771107997_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M154.5,473.2C40.9,417,10.3,330.9,8.9,262.6C3-40.9,419.1-94.5,488,206.7c2.8,12-0.2,12.2-2.2,15.4 c-0.5,0.8-37.1-7.6-38.9,1.9c-18,95-160.1,103.8-139.6-4.7c16.4-86.5-8.4-82-15.7-69.9c-58.1,97.5-173,44.7-141.3,141.6 c9.7,29.6,44.8,39.7,63.5,40.8c52.6,3.1,79.9-23.5,81.5-26.2c0-0.1,0.1-0.1,0.1-0.2l0,0c1.5-1.8,4.3,0.1,3.1,2.1 c-3.8,6.6-9,14.2-15.2,20.1c-12.7,11.8-42.2,29.8-76.6,23.8c-61.9-10.9-86.2-37.2-90.8-105.3c-1.7-25.1,66.6-32.2,103.9-51.7 c74-38.7,60.5-60,79.3-65.3c7.2-2,29.4,7.4,21.9,54.7c-22.3,140.5,99.6,102.4,119.6,37.6c2.9-9.3,9.2-6.3,20.8-7.2 c10.4-0.8,17.8-1.9,11.1-23.6c-86.3-278.5-464.8-164-431.6,85c15.1,113.7,166.1,193,258,155.8c117.3-51.5,128.7-141.1,170.4-77.6 c12.2,28.4-17.4,108.6-163.7,135.4C245.6,500.2,190.6,491,154.5,473.2z M432,218L432,218L432,218z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M218,234.2c-6,3.5-7.2,2.2-4.5-0.7c3.4-3.6,27.3-24.8,39.3-3.6c4.4,7.8-8.1-0.1-13.6-1.3 C231.8,227.5,224.3,230.5,218,234.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M386.1,215.2c-3.7,5.4-2.5,6.6,0.5,4.2c3.7-3.1,25.8-24.5,5.1-36.1c-7.6-4.3-0.2,7.4,0.8,12.6 C393.3,202.6,390.1,209.4,386.1,215.2z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoW);
export default __webpack_public_path__ + "static/media/logo_w.f37b2867b7bd1edd8d48bc9affcc1a73.svg";
export { ForwardRef as ReactComponent };